import * as React from 'react';
import { FC } from 'react';

import { HStack, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import Link from 'components/link';
import { routes } from 'utils/routing';

import theme from './theme';

export interface ISubcategoryBreadcrumbs {
  currentSectionName: string;
}

const StyledLink = Link.withConfig({
  color: theme.wrapperColor,
});

export const SubcategoryBreadcrumbs: FC<React.PropsWithChildren<ISubcategoryBreadcrumbs>> = ({
  currentSectionName,
}) => {
  const { formatMessage } = useIntl();
  return (
    <HStack paddingTop="$4" alignSelf="center" flexWrap="wrap" justifyContent="center">
      <StyledLink to={routes.supportCategories} isInline isUnderlined>
        {formatMessage({ id: 'supportTopicsAll' })}
      </StyledLink>
      <Text alignSelf="flex-start" fontSize="lg">
        {' / ' + currentSectionName}
      </Text>
    </HStack>
  );
};
